import React, {useEffect, useRef, useState} from 'react';
import { StyledVideoScrollYoutube } from './StyledVideoScrollYoutube';
import { gsap } from "gsap";
import YouTube from 'react-youtube';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const VideoScrollYoutube = ({ idVideo, align }) => {
  const videoHolderRef = useRef(null);
  const videoRef = useRef(null);
  const [videoEl, setVideoEl] = useState(null);
  
  const _onReady =  (e) => {
    setVideoEl(e.target)
  }

  const opts = {
    playerVars:{
      rel: 0
    }
  }

  useEffect(() => {

    
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    
    if(videoEl != null){
      ScrollTrigger.create({
        trigger: videoHolderRef.current,
        start: 'top center',
        end: 'bottom top',
        id: idVideo,
        scrub: 0.1,
        onEnter: () => {
          
          gsap.to(videoRef.current, {width: "100%", left: 0, right: 0, margin: 0, padding: 0, onComplete: () =>{
  
            // videoEl.playVideo()
          }})
        },
        onLeave: () => {
          var leaveWidth = '83.3%';
          var leaveLeft =  window.innerWidth <= 768 ? 'auto' :  '8.33%';
          var leaveRight = window.innerWidth <= 768 ? 'auto' :  '8.33%';
          var leavePaddingRight = window.innerWidth <= 768 ? 0 : window.innerWidth <= 1023 ? 32 : 48
          var leavePaddingLeft = window.innerWidth <= 768 ? 0 : window.innerWidth <= 1023 ? 32 : 48
          var leaveMarginLeft = "8.33%" 
          var leaveMarginRight = "8.33%"
          var leaveBottom = window.innerWidth <= 768 ? -80 : window.innerWidth <= 1023 ? -128 : -160;
          
  
          if(align !== 'right')
            gsap.to(videoRef.current,
              {width: leaveWidth, bottom: leaveBottom, marginLeft: leaveMarginLeft, left: leaveLeft, paddingRight: leavePaddingRight, 
                onComplete: () =>{
                // videoEl.pauseVideo()
              }
            })
          else 
            gsap.to(videoRef.current,
              {width: leaveWidth, bottom: leaveBottom, marginRight: leaveMarginRight, right: leaveRight, paddingLeft: leavePaddingLeft, 
                onComplete: () =>{
                // videoEl.pauseVideo()
              }
            })
        },
        onEnterBack: () => {
          gsap.to(videoRef.current, {width: "100%", left: 0,  right: 0, margin: 0, padding: 0, onComplete: () =>{
            // videoEl.playVideo()
          }})
        },
        onLeaveBack: () => {
  
          var leaveWidth = '83.3%';
          var leaveLeft =  window.innerWidth <= 768 ? 'auto' :  '8.33%';
          var leaveRight = window.innerWidth <= 768 ? 'auto' :  '8.33%';
          var leavePaddingRight = window.innerWidth <= 768 ? 0 : window.innerWidth <= 1023 ? 32 : 48
          var leavePaddingLeft = window.innerWidth <= 768 ? 0 : window.innerWidth <= 1023 ? 32 : 48
          var leaveMarginLeft = "8.33%" 
          var leaveMarginRight = "8.33%"
          var leaveBottom = window.innerWidth <= 768 ? -80 : window.innerWidth <= 1023 ? -128 : -160;
          
  
          gsap.to(videoRef.current,
            {width: leaveWidth, bottom: leaveBottom, marginRight: leaveMarginRight, right: leaveRight,marginLeft: leaveMarginLeft, left: leaveLeft, paddingRight: leavePaddingRight, 
              onComplete: () =>{
              // videoEl.pauseVideo()
            }
          })
        }
      })
    }
 
  }, [videoEl])

  return (
    <React.Fragment>
      {
       
          <StyledVideoScrollYoutube
          ref={videoHolderRef}
          className={align}
          >
            <div className="video--wrap" ref={videoRef}>
              <YouTube videoId={idVideo} opts={opts} onReady={_onReady} /> 
            </div>            
          </StyledVideoScrollYoutube>
          
      }
    </React.Fragment>
  );
};

export default VideoScrollYoutube;
